import { AlertCircle } from "lucide-react";

import { Alert, AlertTitle } from "./ui/alert";

import type { ReactNode } from "react";

interface ErrorBoxProps {
  title?: string;
  text: string;
  marginBottom?: number | string;
  /** Optional call to action rendered inside the box, under the message. */
  action?: ReactNode;
}

export const ErrorBox = (props: ErrorBoxProps) => {
  const { title, text, action } = props;

  const renderMessages = () => {
    const messages = text.split("\n");

    if (messages.length > 1) {
      return (
        <ul className="list-disc pl-4">
          {messages.map((msg, index) => (
            <li key={index} className="py-1 list-item">
              <p
                data-test-id={`error-message-${index}`}
                className="text-sm leading-5"
              >
                {msg}
              </p>
            </li>
          ))}
        </ul>
      );
    }

    return (
      <p data-test-id="error-message" className="text-sm leading-5">
        {text}
      </p>
    );
  };

  return (
    <Alert variant="destructive">
      <AlertCircle />
      {title && (
        <AlertTitle>
          <span data-test-id="error-title" className="text-sm font-bold">
            {title}
          </span>
        </AlertTitle>
      )}

      {renderMessages()}

      {action && <div className="mt-3">{action}</div>}
    </Alert>
  );
};
